export default {
  'database.title': 'Database',
  'database.create': 'Create Database',
  'database.mySql': 'MySQL',
  'database.redis': 'Redis',
  'database.milvus': 'Milvus',
  'database.sqlite': 'SQLite',
  'database.more': 'More databases coming soon...',
  'database.create.mysql': 'Create MySQL Database',
  'database.create.redis': 'Create Redis Instance',
  'database.columns.instances': 'Instances',
  'database.columns.status': 'Status',
  'database.columns.type': 'Type',
  'database.columns.plan': 'Plan',
  'database.columns.region': 'Region',
  'database.columns.creationTime': 'Creation Time',
  'database.columns.actions': 'Actions',
  'database.columns.keyName': 'Key',
  'database.status.running': 'Running',
  'database.type.singleNode': 'Single Node',
  'database.plan.basic': 'Basic',
  'database.region.asiaSingapore': 'Asia-Singapore',
  'database.action.edit': 'Edit',
  'database.action.delete': 'Delete',
  'database.action.delete.confirm':
    'Are you sure you want to delete this database?',
  'database.action.delete.key.confirm':
    'Are you sure you want to delete this key?',
  'database.create.success': 'Created database {name} successfully',
  'database.create.fail': 'Failed to create database {name}: {message}',
  'database.delete.success': 'Deleted database {name} successfully',
  'database.delete.fail': 'Failed to delete database {name}: {error}',
  'database.metrics': 'Metrics',
  'database.metrics.timeRange': 'Time Range',
  'database.metrics.precision': 'Precision',
  'database.metrics.range1h': 'Last 1 Hour',
  'database.metrics.range6h': 'Last 6 Hours',
  'database.metrics.range1d': 'Last 1 Day',
  'database.metrics.range7d': 'Last 7 Days',
  'database.metrics.range30d': 'Last 30 Days',
  'database.metrics.precision1m': '1 min',
  'database.metrics.precision5m': '5 min',
  'database.metrics.precision15m': '15 min',
  'database.metrics.precision1h': '1 hour',
  'database.metrics.cpu': 'CPU Usage',
  'database.metrics.memory': 'Memory Usage',
  'database.metrics.storage': 'Persistent Storage Usage',
  'database.metrics.noData': 'No monitoring data',
  'database.metrics.fetchFailed': 'Failed to fetch metrics',
  // Redis Instance Management
  'database.redis.createInstance': 'Create Instance',
  'database.redis.instanceId': 'Instance ID',
  'database.redis.instanceName': 'Instance Name',
  'database.redis.name': 'Alias',
  'database.redis.status': 'Status',
  'database.redis.type': 'Deployment Mode',
  'database.redis.plan': 'Plan',
  'database.redis.region': 'Region',
  'database.redis.creationTime': 'Creation Time',
  'database.redis.operation': 'Actions',
  'database.redis.delete': 'Delete',
  'database.redis.deleteConfirm': 'Confirm Delete',
  'database.redis.deleteConfirmContent':
    'Are you sure you want to delete instance {name}?',
  'database.redis.deleteSuccess': 'Delete successful',
  'database.redis.deleteFail': 'Delete failed',
  'database.redis.fetchListFail': 'Failed to fetch instance list',
  // Create Instance Modal
  'database.redis.createModal.title': 'Create Redis Database Instance',
  'database.redis.createModal.name': 'Alias',
  'database.redis.createModal.namePlaceholder': 'Please enter alias',
  'database.redis.createModal.nameRequired': 'Please enter alias',
  'database.redis.createModal.instanceName': 'Instance Name',
  'database.redis.createModal.instanceNamePlaceholder':
    'Please enter instance name',
  'database.redis.createModal.instanceNameRequired':
    'Please enter instance name',
  'database.redis.createModal.instanceNameInvalid':
    'The instance name must start with a letter and can only contain letters, numbers, and underscores',
  'database.redis.createModal.region': 'Region',
  'database.redis.createModal.regionRequired': 'Please select region',
  'database.redis.createModal.type': 'Type',
  'database.redis.createModal.typeRequired': 'Please select type',
  'database.redis.createModal.typeSingleNode': 'Single Node',
  'database.redis.createModal.typeHighAvailability': 'High Availability',
  'database.redis.createModal.plan': 'Plan',
  'database.redis.createModal.planRequired': 'Please select plan',
  'database.redis.createModal.availabilityMode': 'Deployment Mode',
  'database.redis.createModal.availabilityModeRequired':
    'Please select deployment mode',
  'database.redis.createModal.modeSingle': 'Single Node',
  'database.redis.createModal.modeMulti': 'High Availability',
  'database.redis.createModal.modeSingleDesc':
    'Suitable for individual developers and small-to-medium teams. Designed for development and testing workloads.',
  'database.redis.createModal.modeMultiDesc':
    'Designed for production workloads requiring high reliability and availability. Built-in redundancy and failover. Supports storage scaling.',
  'database.redis.createModal.flavor': 'Flavor',
  'database.redis.createModal.flavorRequired': 'Please select flavor',
  'database.redis.createModal.version': 'Redis Version',
  'database.redis.createModal.createSuccess': 'Create request sent',
  'database.redis.createModal.createFail': 'Create failed',
  'database.redis.createModal.fetchRegionsFail':
    'Failed to fetch available regions',
  'database.redis.createModal.fetchFlavorsFail':
    'Failed to fetch available flavors',
  'database.redis.createModal.creditsPerHour': ' credits/hour',
  'database.redis.createModal.computeCredits': 'Compute Resources',
  'database.redis.createModal.storageCredits': 'Storage Resources',
  'database.redis.createModal.totalCredits':
    'Total hourly consumption: {credits} credits',
  'database.redis.createModal.connectionConfigName':
    'Connection Configuration Name',
  'database.redis.createModal.connectionConfigNamePlaceholder':
    'Leave empty to auto-generate: Redis-{host}-{User}',
  'database.redis.createModal.connectionConfigNameTip':
    'Identifies the connection configuration for this Redis instance in the configuration center. Bound to the instance and cannot be deleted after creation.',
  'database.redis.createModal.instanceNameAutoHint':
    'Auto-generated if left empty',
  // Instance List Enhancements
  'database.redis.filterByStatus': 'Filter by Status',
  'database.redis.statusRunning': 'Running',
  'database.redis.statusCreating': 'Creating',
  'database.redis.statusDeleting': 'Deleting',
  'database.redis.statusDeleted': 'Deleted',
  'database.redis.statusUpgrading': 'Upgrading',
  'database.redis.showDeleted': 'Show Deleted',
  'database.redis.hideDeleted': 'Hide Deleted',
  'database.redis.deleted': 'Deleted',
  'database.redis.manage': 'Manage',
  // Instance Details
  'database.redis.fetchInstanceFail': 'Failed to fetch instance details',
  'database.redis.keys': 'Key Management',
  'database.redis.createKey': 'Create Key',
  'database.redis.searchKeyPlaceholder': 'Filter by key pattern (e.g., user:*)',
  'database.redis.fetchKeysFail': 'Failed to fetch key list',
  // Redis Key Modal
  'database.redis.keyModal.editTitle': 'Edit Redis Key',
  'database.redis.keyModal.createTitle': 'Create Redis Key',
  'database.redis.keyModal.saving': 'Saving...',
  'database.redis.keyModal.save': 'Save',
  'database.redis.keyModal.loading': 'Loading...',
  'database.redis.keyModal.keyName': 'Redis Key Name',
  'database.redis.keyModal.keyNamePlaceholder': 'Please enter',
  'database.redis.keyModal.keyNameRequired': 'Please enter Redis key name',
  'database.redis.keyModal.keyType': 'Redis Key Type',
  'database.redis.keyModal.keyTypePlaceholder': 'Please select',
  'database.redis.keyModal.keyTypeRequired': 'Please select Redis key type',
  'database.redis.keyModal.keyValue': 'Redis Key Value',
  'database.redis.keyModal.stringPlaceholder': 'Please enter string value',
  'database.redis.keyModal.startIndex': 'Start Index',
  'database.redis.keyModal.endIndex': 'End Index',
  'database.redis.keyModal.search': 'Search',
  'database.redis.keyModal.noData': 'No data',
  'database.redis.keyModal.fieldName': 'Field Name',
  'database.redis.keyModal.fieldValue': 'Field Value',
  'database.redis.keyModal.fieldNamePlaceholder': 'Field Name',
  'database.redis.keyModal.fieldValuePlaceholder': 'Field Value',
  'database.redis.keyModal.copyFieldValue': 'Copy field value',
  'database.redis.keyModal.add': 'Add',
  'database.redis.keyModal.expiration': 'Redis Key Expiration (seconds)',
  'database.redis.keyModal.expirationPlaceholder': '0 means permanent',
  'database.redis.keyModal.seconds': 'sec',
  'database.redis.keyModal.fieldAndValueRequired':
    'Field name and value cannot be empty',
  'database.redis.keyModal.saveHashFieldFailed': 'Failed to save hash field',
  'database.redis.keyModal.stringEmptyAllowed':
    'Empty strings are allowed as values.',
  'database.redis.keyModal.hashFieldRequired':
    'A Hash key must contain at least one field.',
  'database.redis.keyModal.copySuccess': 'Copied successfully',
  'database.redis.keyModal.copyFailed': 'Copy failed',
  'database.redis.keyModal.loadKeyFailed': 'Failed to load key info: {error}',
  'database.redis.keyModal.expiresAt': 'Expires at {time}',
  'database.redis.keyModal.permanent': 'Permanent (never expires)',
  'database.redis.keyModal.saveKeyFailed': 'Failed to save key value',
  // Redis Hook Messages
  'database.redis.hook.setKeySuccess': 'Key value set successfully',
  'database.redis.hook.setKeyFail': 'Failed to set key value',
  'database.redis.hook.getKeyFail': 'Failed to get key value',
  'database.redis.hook.deleteKeysSuccess':
    'Successfully deleted {count} key(s)',
  'database.redis.hook.deleteKeysFail': 'Failed to delete key(s)',
  'database.redis.hook.getTTLFail': 'Failed to get TTL',
  'database.redis.hook.getKeyTypeFail': 'Failed to get key type',
  'database.redis.hook.setHashFieldSuccess': 'Hash field set successfully',
  'database.redis.hook.setHashFieldFail': 'Failed to set hash field',
  'database.redis.hook.getHashFieldsFail': 'Failed to get all hash fields',
  'database.redis.hook.deleteHashFieldsSuccess':
    'Hash field(s) deleted successfully',
  'database.redis.hook.deleteHashFieldsFail': 'Failed to delete hash field(s)',
  'database.redis.hook.getListLengthFail': 'Failed to get list length',
  'database.redis.hook.getListRangeFail': 'Failed to get list range',
  // MySQL Instance Management
  'database.mysql.createInstance': 'Create Instance',
  'database.mysql.instanceId': 'Instance ID',
  'database.mysql.instanceName': 'Instance Name',
  'database.mysql.name': 'Alias',
  'database.mysql.status': 'Status',
  'database.mysql.type': 'Deployment Mode',
  'database.mysql.plan': 'Plan',
  'database.mysql.region': 'Region',
  'database.mysql.creationTime': 'Creation Time',
  'database.mysql.operation': 'Actions',
  'database.mysql.delete': 'Delete',
  'database.mysql.deleteConfirm': 'Confirm Delete',
  'database.mysql.deleteConfirmContent':
    'Are you sure you want to delete instance {name}?',
  'database.mysql.deleteSuccess': 'Delete successful',
  'database.mysql.deleteFail': 'Delete failed',
  'database.mysql.fetchListFail': 'Failed to fetch instance list',
  // Create Instance Modal
  'database.mysql.createModal.title': 'Create MySQL Database Instance',
  'database.mysql.createModal.name': 'Alias',
  'database.mysql.createModal.namePlaceholder': 'Please enter alias',
  'database.mysql.createModal.nameRequired': 'Please enter alias',
  'database.mysql.createModal.instanceName': 'Instance Name',
  'database.mysql.createModal.instanceNamePlaceholder':
    'Please enter instance name',
  'database.mysql.createModal.instanceNameAutoGen':
    'Leave blank to auto-generate (e.g. mysql_instance_ab12)',
  'database.mysql.createModal.instanceNameRequired':
    'Please enter instance name',
  'database.mysql.createModal.instanceNameInvalid':
    'The instance name must start with a letter and can only contain letters, numbers, and underscores',
  'database.mysql.createModal.region': 'Region',
  'database.mysql.createModal.regionRequired': 'Please select region',
  'database.mysql.createModal.type': 'Type',
  'database.mysql.createModal.typeRequired': 'Please select type',
  'database.mysql.createModal.typeSingleNode': 'Single Node',
  'database.mysql.createModal.typeHighAvailability': 'High Availability',
  'database.mysql.createModal.plan': 'Plan',
  'database.mysql.createModal.planRequired': 'Please select plan',
  'database.mysql.createModal.availabilityMode': 'Deployment Mode',
  'database.mysql.createModal.availabilityModeRequired':
    'Please select deployment mode',
  'database.mysql.createModal.modeSingle': 'Single Node',
  'database.mysql.createModal.modeMulti': 'High Availability',
  'database.mysql.createModal.modeSingleDesc':
    'Suitable for individual developers and small-to-medium teams. Designed for development and testing workloads.',
  'database.mysql.createModal.modeMultiDesc':
    'Designed for production workloads requiring high reliability and availability. Built-in redundancy and failover. Supports storage scaling.',
  'database.mysql.createModal.flavor': 'Flavor',
  'database.mysql.createModal.flavorRequired': 'Please select flavor',
  'database.mysql.createModal.storage': 'Storage',
  'database.mysql.createModal.storageUnit': 'GB',
  'database.mysql.createModal.version': 'MySQL Version',
  'database.mysql.createModal.planBasic': 'Basic (1 Core, 2 GB RAM)',
  'database.mysql.createModal.planBasicHA': 'Basic (2 Cores, 4 GB RAM)',
  'database.mysql.createModal.planStarter': 'Starter (2 Cores, 2 GB RAM)',
  'database.mysql.createModal.planLaunch': 'Launch (2 Cores, 4 GB RAM)',
  'database.mysql.createModal.planScale': 'Scale (4 Cores, 8 GB RAM)',
  'database.mysql.createModal.planPerformance':
    'Performance (8 Cores, 16 GB RAM)',
  'database.mysql.createModal.quotaExceeded':
    'Free plan resource quota exceeded, please upgrade your plan',
  'database.mysql.createModal.pointsInsufficient':
    'Insufficient points, please recharge or upgrade your plan',
  'database.mysql.createModal.createSuccess': 'Create request sent',
  'database.mysql.createModal.createFail': 'Create failed',
  'database.mysql.createModal.fetchRegionsFail':
    'Failed to fetch available regions',
  'database.mysql.createModal.fetchStorageRangeFail':
    'Failed to fetch storage range',
  'database.mysql.createModal.fetchFlavorsFail':
    'Failed to fetch available flavors',
  'database.mysql.createModal.creditsPerHour': ' credits/hour',
  'database.mysql.createModal.computeCredits': 'Compute Resources',
  'database.mysql.createModal.storageCredits': 'Storage Resources',
  'database.mysql.createModal.storageNoExpand': 'No expansion supported',
  'database.mysql.createModal.totalCredits':
    'Total hourly consumption: {credits} credits',
  // Instance List Enhancements
  'database.mysql.filterByStatus': 'Filter by Status',
  'database.mysql.statusRunning': 'Running',
  'database.mysql.statusCreating': 'Creating',
  'database.mysql.statusDeleting': 'Deleting',
  'database.mysql.statusDeleted': 'Deleted',
  'database.mysql.statusUpgrading': 'Upgrading',
  'database.mysql.showDeleted': 'Show Deleted',
  'database.mysql.hideDeleted': 'Hide Deleted',
  'database.mysql.deleted': 'Deleted',
  'database.mysql.manage': 'Manage',
  'database.mysql.deleteDatabase': 'Delete',
  'database.mysql.deleteDatabaseConfirm': 'Delete Database',
  'database.mysql.deleteDatabaseConfirmContent':
    'Are you sure you want to delete database "{name}"? This action cannot be undone.',
  'database.mysql.deleteDatabaseSuccess': 'Database deleted successfully',
  'database.mysql.deleteDatabaseFail': 'Failed to delete database',
  // Instance Details
  'database.mysql.viewUsage': 'View Usage',
  'database.mysql.usageComingSoon': 'Monitoring feature coming soon',
  'database.mysql.fetchInstanceFail': 'Failed to fetch instance details',
  'database.mysql.databases': 'Databases',
  'database.mysql.createDatabase': 'Create Database',
  'database.mysql.fetchDatabasesFail': 'Failed to fetch database list',
  // Database Management
  'database.mysql.databaseName': 'Database Name',
  'database.mysql.databaseNamePlaceholder':
    'Please enter database name (start with a lowercase letter, only contain lowercase letters, numbers, and underscores)',
  'database.mysql.databaseNameRequired': 'Please enter database name',
  'database.mysql.databaseNameMustStartWithLetter':
    'Database name must start with a lowercase letter',
  'database.mysql.databaseNameInvalidChars':
    'Database name can only contain lowercase letters, numbers, and underscores',
  'database.mysql.databaseNameTooLong':
    'Database name cannot exceed 64 characters',
  'database.mysql.description': 'Description',
  'database.mysql.descriptionPlaceholder':
    'Please enter database description (optional)',
  'database.mysql.connectionConfigName': 'Connection Configuration Name',
  'database.mysql.connectionConfigNamePlaceholder':
    'Leave empty to auto-generate',
  'database.mysql.connectionConfigNameTip':
    'Used to identify the connection configuration for this database, will appear in the configuration center',
  'database.mysql.createDatabaseSuccess': 'Database created successfully',
  'database.mysql.createDatabaseFail': 'Failed to create database',
  // Table Management
  'database.mysql.createTable': 'Create Table',
  'database.mysql.editTable': 'Edit Table',
  'database.mysql.copyTable': 'Copy Table',
  'database.mysql.copyTableSchema': 'Copy Table Schema',
  'database.mysql.copyTableSchemaSuccess': 'Schema copied to clipboard',
  'database.mysql.copyTableSchemaFail': 'Failed to copy',
  'database.mysql.exportTableData': 'Export Table Data',
  'database.mysql.exportTableDataSuccess': 'Export successful',
  'database.mysql.exportTableDataFail': 'Export failed',
  'database.mysql.deleteTable': 'Delete Table',
  'database.mysql.deleteTableConfirm':
    'Are you sure you want to delete table {name}? This action cannot be undone.',
  'database.mysql.deleteTableSuccess': 'Table deleted successfully',
  'database.mysql.deleteTableFail': 'Failed to delete table',
  'database.mysql.structure': 'Schema',
  'database.mysql.content': 'Data',
  'database.mysql.query': 'Query',
  'database.mysql.targetTableName': 'Target Table Name',
  'database.mysql.targetTableNamePlaceholder': 'Please enter target table name',
  'database.mysql.targetTableNameRequired': 'Please enter target table name',
  'database.mysql.copyData': 'Copy Data',
  'database.mysql.copyDataTip':
    'If checked, table data will be copied along with the structure, otherwise only the structure will be copied',
  'database.mysql.copyTableSuccess': 'Table copied successfully',
  'database.mysql.copyTableFail': 'Failed to copy table',
  'database.mysql.editTableTip':
    'Please use DDL SQL statements to edit table structure',
  'database.mysql.ddlSqlPlaceholder': 'Please enter DDL SQL statement',
  'database.mysql.ddlSqlRequired': 'Please enter DDL SQL statement',
  'database.mysql.fetchTableSchemaFail': 'Failed to fetch table schema',
  'database.mysql.editTableSuccess': 'Table edited successfully',
  'database.mysql.editTableFail': 'Failed to edit table',
  // Table Structure Management
  'database.mysql.addField': 'Add Field',
  'database.mysql.fieldName': 'Field Name',
  'database.mysql.fieldDescription': 'Description',
  'database.mysql.dataType': 'Data Type',
  'database.mysql.length': 'Length',
  'database.mysql.defaultValue': 'Default Value',
  'database.mysql.required': 'Required',
  'database.mysql.unique': 'Unique',
  'database.mysql.autoIncrement': 'Auto Increment',
  'database.mysql.primaryKey': 'Primary Key',
  'database.mysql.deleteFieldConfirm':
    'Are you sure you want to delete this field?',
  'database.mysql.fieldNameEmpty': 'Field name cannot be empty!',
  'database.mysql.fieldNameDuplicate': 'Field names cannot be duplicated!',
  // Table Data Management
  'database.mysql.selectField': 'Select Field',
  'database.mysql.operator': 'Operator',
  'database.mysql.inputValue': 'Input Value',
  'database.mysql.search': 'Search',
  'database.mysql.reset': 'Reset',
  'database.mysql.addRow': 'Add Row',
  'database.mysql.clear': 'Delete All Data',
  'database.mysql.showFields': 'Show Fields',
  'database.mysql.selectFieldsToShow': 'Select fields to display',
  'database.mysql.defaultValueTip': 'Default value for this field: {value}',
  'database.mysql.deleteRowConfirm':
    'Are you sure you want to delete this row?',
  'database.mysql.clearTableData': 'Clear Table Data',
  'database.mysql.clearTableDataConfirm': 'Confirm clear data?',
  'database.mysql.clearTableDataWarning':
    'Data cannot be recovered after clearing. Please proceed with caution.',
  'database.mysql.operatorEqual': 'Equal',
  'database.mysql.operatorNotEqual': 'Not Equal',
  'database.mysql.operatorGreater': 'Greater Than',
  'database.mysql.operatorGreaterEqual': 'Greater Than or Equal',
  'database.mysql.operatorLess': 'Less Than',
  'database.mysql.operatorLessEqual': 'Less Than or Equal',
  'database.mysql.operatorLike': 'Contains',
  'database.mysql.operatorStarts': 'Starts With',
  'database.mysql.operatorEnds': 'Ends With',
  'database.mysql.operatorIsNull': 'Is Null',
  'database.mysql.operatorIsNotNull': 'Is Not Null',
  // SQL Execution
  'database.mysql.sqlPlaceholder': 'Please enter SQL statement',
  'database.mysql.clearSQL': 'Clear',
  'database.mysql.executeSQL': 'Execute',
  'database.mysql.sqlEmptyState':
    'Please enter SQL statement above and click execute',
  'database.mysql.sqlInputRequired': 'Please enter SQL statement',
  'database.mysql.sqlExecuteSuccess':
    'Execution successful, affected {rows} rows',
  'database.mysql.sqlExecuteFail': 'Execution failed: {error}',
  // useMysql hook messages
  'database.mysql.getDatabaseInfoFail':
    'Failed to get database {database} info: {error}',
  'database.mysql.addTableSuccess': 'Table {name} added successfully!',
  'database.mysql.addTableFail': 'Failed to add table {name}: {error}',
  'database.mysql.getTableColumnsFail':
    'Failed to get table {table} column info: {error}',
  'database.mysql.getTableDataFail':
    'Failed to get table {table} data info: {error}',
  'database.mysql.updateTableColumnSuccess':
    'Table {table} column info updated successfully!',
  'database.mysql.updateTableColumnFail':
    'Failed to update table {table} column info: {error}',
  'database.mysql.addColumnSuccess': 'Column {name} added successfully!',
  'database.mysql.addColumnFail': 'Failed to add column {name}: {error}',
  'database.mysql.deleteColumnSuccess': 'Column {name} deleted successfully!',
  'database.mysql.deleteColumnFail': 'Failed to delete column {name}: {error}',
  'database.mysql.addRowSuccess': 'Row added successfully!',
  'database.mysql.addRowFail': 'Failed to add row: {error}',
  'database.mysql.fieldDefaultValue': 'Default value: {value}',
  'database.mysql.updateRowSuccess': 'Row updated successfully!',
  'database.mysql.updateRowFail': 'Failed to update row: {error}',
  'database.mysql.deleteRowSuccess': 'Row deleted successfully!',
  'database.mysql.deleteRowFail': 'Failed to delete row: {error}',
  'database.mysql.clearTableDataSuccess':
    'Table {table} data cleared successfully!',
  'database.mysql.clearTableDataFail':
    'Failed to clear table {table} data: {error}',
  'database.mysql.executeSQLSuccess': 'SQL executed successfully!',
  'database.mysql.executeSQLFail': 'SQL execution failed: {error}',
  // Create Table
  'database.mysql.createTableModal.title': 'Create Table',
  'database.mysql.createTableModal.tableName': 'Table Name',
  'database.mysql.createTableModal.tableNamePlaceholder':
    'Please enter table name',
  'database.mysql.createTableModal.tableNameRequired':
    'Please enter table name',
  'database.mysql.createTableModal.columns': 'Table Columns',
  'database.mysql.createTableModal.addField': 'Add Field',
  'database.mysql.createTableModal.fieldName': 'Field Name',
  'database.mysql.createTableModal.fieldNamePlaceholder':
    'Please enter field name',
  'database.mysql.createTableModal.description': 'Description',
  'database.mysql.createTableModal.descriptionPlaceholder':
    'Please enter field description',
  'database.mysql.createTableModal.dataType': 'Data Type',
  'database.mysql.createTableModal.size': 'Size',
  'database.mysql.createTableModal.defaultValue': 'Default Value',
  'database.mysql.createTableModal.required': 'Required',
  'database.mysql.createTableModal.unique': 'Unique',
  'database.mysql.createTableModal.autoIncrement': 'Auto Increment',
  'database.mysql.createTableModal.primaryKey': 'Primary Key',
  'database.mysql.createTableModal.delete': 'Delete',
  'database.mysql.createTableModal.columnsRequired': 'Please add fields',
  'database.mysql.createTableModal.fieldNameEmpty':
    'Field name cannot be empty!',
  'database.mysql.createTableModal.fieldNameDuplicate':
    'Field names cannot be duplicated!',
  'database.mysql.createTableModal.primaryKeyRequired':
    'Please specify a primary key!',
  // Milvus Instance Management
  'database.milvus.createInstance': 'Create Instance',
  'database.milvus.instanceId': 'Instance ID',
  'database.milvus.instanceName': 'Instance Name',
  'database.milvus.name': 'Alias',
  'database.milvus.status': 'Status',
  'database.milvus.mode': 'Deployment Mode',
  'database.milvus.plan': 'Plan',
  'database.milvus.region': 'Region',
  'database.milvus.creationTime': 'Creation Time',
  'database.milvus.operation': 'Actions',
  'database.milvus.delete': 'Delete',
  'database.milvus.manage': 'Manage',
  'database.milvus.deleted': 'Deleted',
  'database.milvus.deleteConfirm': 'Confirm Delete',
  'database.milvus.deleteConfirmTitle': 'Delete Milvus Instance',
  'database.milvus.deleteConfirmContent':
    'Are you sure you want to delete instance {name}? All collections and data will be released and cannot be recovered.',
  'database.milvus.deleteSuccess': 'Delete successful',
  'database.milvus.deleteFail': 'Delete failed',
  'database.milvus.fetchListFail': 'Failed to fetch instance list',
  'database.milvus.fetchInstanceFail': 'Failed to fetch instance details',
  'database.milvus.statusRunning': 'Running',
  'database.milvus.statusCreating': 'Creating',
  'database.milvus.statusDeleting': 'Deleting',
  'database.milvus.statusDeleted': 'Deleted',
  'database.milvus.statusUpgrading': 'Upgrading',
  'database.milvus.statusSuspended': 'Suspended',
  'database.milvus.filterByStatus': 'Filter by Status',
  'database.milvus.notOwnerTip':
    'Only workspace owners can create Milvus instances',
  // Create Instance Modal
  'database.milvus.createModal.title': 'Create Milvus Database Instance',
  'database.milvus.createModal.name': 'Alias',
  'database.milvus.createModal.namePlaceholder':
    'Enter an alias (e.g. Dev Database)',
  'database.milvus.createModal.nameRequired': 'Please enter an alias',
  'database.milvus.createModal.instanceName': 'Instance Name',
  'database.milvus.createModal.instanceNamePlaceholder':
    'Leave empty to auto-generate',
  'database.milvus.createModal.instanceNameInvalid':
    'The value must be 2 to 255 characters in length and can contain letters, digits, underscores. It must start with a letter.',
  'database.milvus.createModal.instanceNameAutoHint':
    'Auto-generated if left empty',
  'database.milvus.createModal.region': 'Region',
  'database.milvus.createModal.regionRequired': 'Please select a region',
  'database.milvus.createModal.availabilityMode': 'Deployment Mode',
  'database.milvus.createModal.availabilityModeRequired':
    'Please select a deployment mode',
  'database.milvus.createModal.modeSingle': 'Single Node',
  'database.milvus.createModal.modeMulti': 'High Availability',
  'database.milvus.createModal.singleNodeDesc':
    'All components run as a single replica with minimal resources. Not recommended for production workloads with SLA guarantees.',
  'database.milvus.createModal.haDesc':
    'High Availability with one primary and two replicas. Suitable for production workloads with manual storage expansion support.',
  'database.milvus.createModal.plan': 'Plan',
  'database.milvus.createModal.planRequired': 'Please select a plan',
  'database.milvus.createModal.flavor': 'Plan',
  'database.milvus.createModal.flavorRequired': 'Please select a plan',
  'database.milvus.createModal.connectionConfigName':
    'Connection Configuration Name',
  'database.milvus.createModal.connectionConfigNamePlaceholder':
    'Leave empty to auto-generate: Milvus-{host}-{User}',
  'database.milvus.createModal.connectionConfigNameTip':
    'Identifies the connection configuration for this Milvus instance in the configuration center. Bound to the instance and cannot be deleted after creation.',
  'database.milvus.createModal.creditsPerHour': ' credits/hour',
  'database.milvus.createModal.createSuccess': 'Create request sent',
  'database.milvus.createModal.createFail': 'Create failed',
  'database.milvus.createModal.fetchFlavorsFail':
    'Failed to fetch available plans',
  'database.milvus.createModal.fetchRegionsFail':
    'Failed to fetch available regions',
  'database.milvus.createModal.quotaExceeded':
    'Resource quota exceeded. Please upgrade your plan.',
  'database.milvus.createModal.pointsInsufficient':
    'Insufficient credits. Please recharge or upgrade your plan.',
  // Instance Details
  'database.milvus.overview': 'Overview',
  'database.milvus.collections': 'Collections',
  'database.milvus.overviewInstanceId': 'Instance ID',
  'database.milvus.overviewInstanceName': 'Instance Name',
  'database.milvus.overviewRegion': 'Region',
  'database.milvus.overviewMode': 'Mode',
  'database.milvus.overviewPlan': 'Plan',
  'database.milvus.overviewStatus': 'Status',
  // Collection List
  'database.milvus.collectionName': 'Collection Name',
  'database.milvus.collectionAliases': 'Aliases',
  'database.milvus.collectionRowCount': 'Row Count',
  'database.milvus.collectionLoadProgress': 'Load Progress',
  'database.milvus.collectionOperation': 'Operation',
  'database.milvus.createCollection': 'Create Collection',
  'database.milvus.fetchCollectionsFail': 'Failed to fetch collection list',
  'database.milvus.deleteCollection': 'Drop Collection',
  'database.milvus.deleteCollectionConfirm':
    'Once you drop the collection, all the data in this collection will be cleaned as well. This action cannot be undone.',
  'database.milvus.deleteCollectionSuccess': 'Collection dropped successfully',
  'database.milvus.deleteCollectionFail': 'Failed to drop collection',
  // Create Collection Modal
  'database.milvus.createCollectionModal.title': 'Create Collection',
  'database.milvus.createCollectionModal.collectionName': 'Collection Name',
  'database.milvus.createCollectionModal.collectionNamePlaceholder':
    'Enter collection name',
  'database.milvus.createCollectionModal.collectionNameRequired':
    'Please enter collection name',
  'database.milvus.createCollectionModal.collectionNameInvalid':
    'Collection name must start with a letter and can only contain lowercase letters, numbers, and underscores. Maximum length is 64 characters.',
  'database.milvus.createCollectionModal.description': 'Description',
  'database.milvus.createCollectionModal.descriptionPlaceholder':
    'Enter collection description (optional)',
  'database.milvus.createCollectionModal.ttl': 'TTL',
  'database.milvus.createCollectionModal.ttlPlaceholder': 'TTL (seconds)',
  'database.milvus.createCollectionModal.dynamicField': 'Dynamic Field',
  'database.milvus.createCollectionModal.dynamicFieldTip':
    'Enable dynamic field to allow adding new fields during insertion without modifying the schema. Suitable for flexible or evolving data structures. May increase storage overhead and affect query performance.',
  'database.milvus.createCollectionModal.schema': 'Schema',
  'database.milvus.createCollectionModal.addField': 'Add Field',
  'database.milvus.createCollectionModal.fieldName': 'Field Name',
  'database.milvus.createCollectionModal.fieldType': 'Field Type',
  'database.milvus.createCollectionModal.fieldDescription': 'Description',
  'database.milvus.createCollectionModal.moreSetting': 'More Settings',
  'database.milvus.createCollectionModal.action': 'Action',
  'database.milvus.createCollectionModal.delete': 'Delete',
  'database.milvus.createCollectionModal.dimension': 'Dimension',
  'database.milvus.createCollectionModal.maxLength': 'Max Length',
  'database.milvus.createCollectionModal.maxCapacity': 'Max Capacity',
  'database.milvus.createCollectionModal.metricType': 'Metric Type',
  'database.milvus.createCollectionModal.indexType': 'Index Type',
  'database.milvus.createCollectionModal.nullable': 'Nullable',
  'database.milvus.createCollectionModal.defaultValue': 'Default Value',
  'database.milvus.createCollectionModal.enableIndex': 'Enable Index',
  'database.milvus.createCollectionModal.autoId': 'Auto ID',
  'database.milvus.createCollectionModal.autoIdTip':
    'Enable to automatically generate primary keys so that you do not need to provide this field during data import.',
  'database.milvus.createCollectionModal.primaryKeyRequired':
    'A primary key field is required',
  'database.milvus.createCollectionModal.vectorFieldRequired':
    'At least one vector field is required',
  'database.milvus.createCollectionModal.fieldNameRequired':
    'Field name cannot be empty',
  'database.milvus.createCollectionModal.fieldNameDuplicate':
    'Field names cannot be duplicated',
  'database.milvus.createCollectionModal.createSuccess':
    'Collection created successfully',
  'database.milvus.createCollectionModal.createFail':
    'Failed to create collection',
  'database.milvus.createCollectionModal.editStructFields':
    'Edit ARRAY<STRUCT> Fields',
  // Collection Management
  'database.milvus.collection.rename': 'Rename',
  'database.milvus.collection.alias': 'Alias',
  'database.milvus.collection.addField': 'Add Field',
  'database.milvus.collection.dataImport': 'Data Import',
  'database.milvus.collection.vectorSearch': 'Vector Search',
  'database.milvus.collection.rowCount': 'Row Count',
  'database.milvus.collection.loadProgress': 'Load Progress',
  'database.milvus.collection.renameModal.title': 'Rename Collection',
  'database.milvus.collection.renameModal.newName': 'New Name',
  'database.milvus.collection.renameModal.newNameRequired':
    'Please enter new name',
  'database.milvus.collection.renameModal.success': 'Renamed successfully',
  'database.milvus.collection.renameModal.fail': 'Rename failed',
  'database.milvus.collection.aliasModal.title': 'Alias Management',
  'database.milvus.collection.aliasModal.setAlias': 'Set Alias',
  'database.milvus.collection.aliasModal.removeAlias': 'Remove Alias',
  'database.milvus.collection.aliasModal.alias': 'Alias',
  'database.milvus.collection.aliasModal.aliasRequired': 'Please enter alias',
  'database.milvus.collection.aliasModal.setSuccess': 'Alias set successfully',
  'database.milvus.collection.aliasModal.setFail': 'Failed to set alias',
  'database.milvus.collection.aliasModal.removeSuccess':
    'Alias removed successfully',
  'database.milvus.collection.aliasModal.removeFail': 'Failed to remove alias',
  'database.milvus.collection.addFieldModal.title': 'Add Field',
  'database.milvus.collection.addFieldModal.tip':
    'Only available for collections with Dynamic Field enabled',
  'database.milvus.collection.addFieldModal.success':
    'Field added successfully',
  'database.milvus.collection.addFieldModal.fail': 'Failed to add field',
  'database.milvus.collection.importModal.title': 'Import Data',
  'database.milvus.collection.importModal.format': 'File Format',
  'database.milvus.collection.importModal.file': 'Select File',
  'database.milvus.collection.importModal.fileTip':
    'Supports JSON/CSV, max 10MB per upload',
  'database.milvus.collection.importModal.fileRequired': 'Please select a file',
  'database.milvus.collection.importModal.partition':
    'Partition Name (optional)',
  'database.milvus.collection.importModal.success':
    'Import successful, {count} records imported',
  'database.milvus.collection.importModal.fail': 'Import failed',
  'database.milvus.collection.search.title': 'Vector Search Playground',
  'database.milvus.collection.search.modeRaw': 'Raw Vector',
  'database.milvus.collection.search.modeEmbedding': 'Embedding Text',
  'database.milvus.collection.search.vectorField': 'Vector Field',
  'database.milvus.collection.search.queryVector': 'Query Vector (JSON array)',
  'database.milvus.collection.search.queryText': 'Query Text',
  'database.milvus.collection.search.embeddingConfig': 'Embedding Config',
  'database.milvus.collection.search.topK': 'Top K',
  'database.milvus.collection.search.outputFields': 'Output Fields',
  'database.milvus.collection.search.filterExpr':
    'Filter Expression (optional)',
  'database.milvus.collection.search.metricType': 'Metric Type',
  'database.milvus.collection.search.execute': 'Search',
  'database.milvus.collection.search.results': 'Search Results',
  'database.milvus.collection.search.noResults': 'No results',
  'database.milvus.collection.search.fail': 'Search failed',
  'database.milvus.collection.fetchStatsFail':
    'Failed to fetch collection stats',
  'database.milvus.collection.fetchDescribeFail':
    'Failed to fetch collection details',
  // Postgres Instance Management
  'database.postgres': 'PostgreSQL',
  'database.postgres.createInstance': 'Create Instance',
  'database.postgres.instanceId': 'Instance ID',
  'database.postgres.instanceName': 'Instance Name',
  'database.postgres.name': 'Alias',
  'database.postgres.status': 'Status',
  'database.postgres.mode': 'Deployment Mode',
  'database.postgres.plan': 'Plan',
  'database.postgres.region': 'Region',
  'database.postgres.creationTime': 'Creation Time',
  'database.postgres.operation': 'Actions',
  'database.postgres.delete': 'Delete',
  'database.postgres.deleteConfirm': 'Confirm Delete',
  'database.postgres.deleteConfirmTitle': 'Delete Instance',
  'database.postgres.deleteConfirmContent':
    'Are you sure you want to delete instance {name}? All databases and data in this instance will be released and cannot be recovered.',
  'database.postgres.deleteSuccess': 'Delete successful',
  'database.postgres.deleteFail': 'Delete failed',
  'database.postgres.fetchListFail': 'Failed to fetch instance list',
  'database.postgres.filterByStatus': 'Filter by status',
  'database.postgres.statusRunning': 'Running',
  'database.postgres.statusCreating': 'Creating',
  'database.postgres.statusDeleting': 'Deleting',
  'database.postgres.statusDeleted': 'Deleted',
  'database.postgres.statusUpgrading': 'Upgrading',
  'database.postgres.statusSuspended': 'Suspended',
  'database.postgres.showDeleted': 'Show deleted',
  'database.postgres.hideDeleted': 'Hide deleted',
  'database.postgres.deleted': 'Deleted',
  // Create Instance Modal
  'database.postgres.createModal.title': 'Create PostgreSQL Instance',
  'database.postgres.createModal.ownerOnly':
    'Only workspace owners can create PostgreSQL instances',
  'database.postgres.createModal.name': 'Alias',
  'database.postgres.createModal.namePlaceholder':
    'Enter an alias (e.g. Development Database)',
  'database.postgres.createModal.nameRequired': 'Please enter an alias',
  'database.postgres.createModal.instanceName': 'Instance Name',
  'database.postgres.createModal.instanceNamePlaceholder':
    'Leave blank to auto-generate',
  'database.postgres.createModal.instanceNameInvalid':
    'The value must be 2 to 255 characters in length and can contain letters, digits, underscores (_). It must start with a letter.',
  'database.postgres.createModal.instanceNameAutoHint':
    'Auto-generated if left empty',
  'database.postgres.createModal.region': 'Region',
  'database.postgres.createModal.regionRequired': 'Please select a region',
  'database.postgres.createModal.deploymentMode': 'Deployment Mode',
  'database.postgres.createModal.deploymentModeRequired':
    'Please select a deployment mode',
  'database.postgres.createModal.singleNode': 'Single Node',
  'database.postgres.createModal.singleNodeDesc':
    'Suitable for individual developers and small-to-medium teams. Designed for development and testing workloads.',
  'database.postgres.createModal.highAvailability': 'High Availability',
  'database.postgres.createModal.highAvailabilityDesc':
    'Designed for production workloads requiring high reliability and availability. Built-in redundancy and failover. Supports storage scaling.',
  'database.postgres.createModal.plan': 'Plan',
  'database.postgres.createModal.planRequired': 'Please select a plan',
  'database.postgres.createModal.storage': 'Storage',
  'database.postgres.createModal.storageUnit': 'GB',
  'database.postgres.createModal.storageRange': '({min} - {max} GB)',
  'database.postgres.createModal.storageNoExpand':
    'Storage size cannot be expanded after creation',
  'database.postgres.createModal.version': 'Postgres Version',
  'database.postgres.createModal.creditsPerHour': 'Credits/hour',
  'database.postgres.createModal.computeCredits': 'Compute',
  'database.postgres.createModal.storageCredits': 'Storage',
  'database.postgres.createModal.totalCredits': 'Total: {credits} credits/hour',
  'database.postgres.createModal.quotaExceeded':
    'Free plan quota exceeded. Please upgrade your plan.',
  'database.postgres.createModal.pointsInsufficient':
    'Insufficient credits. Please top up or upgrade your plan.',
  'database.postgres.createModal.createSuccess': 'Create request sent',
  'database.postgres.createModal.createFail': 'Create failed',
  'database.postgres.createModal.fetchAvailabilityModesFail':
    'Failed to fetch availability modes',
  'database.postgres.createModal.fetchRegionsFail':
    'Failed to fetch available regions',
  'database.postgres.createModal.fetchStorageRangeFail':
    'Failed to fetch storage range',
  'database.postgres.createModal.fetchFlavorsFail':
    'Failed to fetch available plans',
  'database.postgres.createModal.createNow': 'Create Now',
  // Instance Detail
  'database.postgres.fetchInstanceFail': 'Failed to fetch instance details',
  'database.postgres.overview': 'Overview',
  'database.postgres.databases': 'Databases',
  'database.postgres.metrics': 'Metrics',
  // Overview Tab
  'database.postgres.overviewInstanceId': 'Instance ID',
  'database.postgres.overviewInstanceName': 'Instance Name',
  'database.postgres.overviewStatus': 'Status',
  'database.postgres.overviewRegion': 'Region',
  'database.postgres.overviewMode': 'Deployment Mode',
  'database.postgres.overviewPlan': 'Plan',
  'database.postgres.overviewStorage': 'Storage',
  'database.postgres.overviewCreatedAt': 'Created At',
  'database.postgres.overviewEngineVersion': 'Version',
  'database.postgres.monitoring': 'Monitoring',
  'database.postgres.monitoringTimeRange': 'Time Range',
  'database.postgres.monitoring1h': 'Last 1 Hour',
  'database.postgres.monitoring6h': 'Last 6 Hours',
  'database.postgres.monitoring3d': 'Last 3 Days',
  'database.postgres.monitoring7d': 'Last 7 Days',
  'database.postgres.monitoringCpu': 'CPU Usage (%)',
  'database.postgres.monitoringMemory': 'Memory Usage (%)',
  'database.postgres.monitoringStorage': 'Storage Used (GB)',
  // Metrics Tab
  'database.postgres.metricsTimeRange': 'Time Range',
  'database.postgres.metricsPrecision': 'Precision',
  'database.postgres.metricsPrecision1m': '1 min',
  'database.postgres.metricsPrecision5m': '5 min',
  'database.postgres.metricsPrecision15m': '15 min',
  'database.postgres.metricsPrecision1h': '1 hour',
  'database.postgres.metricsCpu': 'CPU Usage',
  'database.postgres.metricsMemory': 'Memory Usage',
  'database.postgres.metricsStorage': 'Persistent Storage Usage',
  'database.postgres.metricsComingSoon': 'Monitoring coming soon',
  // Database Management
  'database.postgres.createDatabase': 'Create Database',
  'database.postgres.databaseName': 'Database Name',
  'database.postgres.databaseNamePlaceholder':
    'Database names must start with a letter and may contain only lowercase letters, numbers, and underscores. The maximum length is 64 characters.',
  'database.postgres.databaseNameRequired': 'Please enter a database name',
  'database.postgres.databaseNameInvalid':
    'Database names must start with a letter and may contain only lowercase letters, numbers, and underscores. The maximum length is 64 characters.',
  'database.postgres.description': 'Description',
  'database.postgres.descriptionPlaceholder': 'Enter description (optional)',
  'database.postgres.connectionConfigName': 'Connection Configuration Name',
  'database.postgres.connectionConfigNamePlaceholder':
    'Leave blank to auto-generate',
  'database.postgres.connectionConfigNameTip':
    'Used to identify the connection configuration for this database, which will appear in the workspace configuration center',
  'database.postgres.createDatabaseSuccess': 'Database created successfully',
  'database.postgres.createDatabaseSuccessDesc':
    'Database created successfully. A workspace PostgreSQL built-in configuration has been generated and can be referenced by workflow database nodes.',
  'database.postgres.viewConfig': 'View Configuration',
  'database.postgres.manageDatabase': 'Manage Database',
  'database.postgres.createDatabaseFail': 'Failed to create database',
  'database.postgres.fetchDatabasesFail': 'Failed to fetch database list',
  'database.postgres.dbName': 'Database Name',
  'database.postgres.dbConfigName': 'Config Name',
  'database.postgres.dbDescription': 'Description',
  'database.postgres.dbCreatedAt': 'Created At',
  'database.postgres.dbOperation': 'Operation',
  'database.postgres.dbManage': 'Manage',
  'database.postgres.dbDelete': 'Delete',
  'database.postgres.dbDeleteConfirm': 'Confirm Delete Database',
  'database.postgres.dbDeleteConfirmContent':
    'Are you sure you want to delete database {name}? This action cannot be undone.',
  'database.postgres.dbDeleteSuccess': 'Database deleted successfully',
  'database.postgres.dbDeleteFail': 'Failed to delete database',
  // Table Management
  'database.postgres.createTable': 'Create Table',
  'database.postgres.editTable': 'Edit Table',
  'database.postgres.copyTable': 'Copy Table',
  'database.postgres.copyTableSchema': 'Copy Table Schema',
  'database.postgres.copyTableSchemaSuccess': 'Schema copied to clipboard',
  'database.postgres.copyTableSchemaFail': 'Failed to copy schema',
  'database.postgres.exportTableData': 'Export Data',
  'database.postgres.exportTableDataSuccess': 'Export successful',
  'database.postgres.exportTableDataFail': 'Export failed',
  'database.postgres.deleteTable': 'Delete Table',
  'database.postgres.deleteTableConfirm':
    'Are you sure you want to delete table {name}? This action cannot be undone.',
  'database.postgres.deleteTableSuccess': 'Table deleted successfully',
  'database.postgres.deleteTableFail': 'Failed to delete table',
  'database.postgres.structure': 'Structure',
  'database.postgres.content': 'Content',
  'database.postgres.query': 'Query',
  'database.postgres.targetTableName': 'Target Table Name',
  'database.postgres.targetTableNamePlaceholder': 'Enter target table name',
  'database.postgres.targetTableNameRequired': 'Please enter target table name',
  'database.postgres.copyData': 'Copy Data',
  'database.postgres.copyDataTip':
    'Check to copy table data along with structure, otherwise only structure is copied',
  'database.postgres.copyTableSuccess': 'Table copied successfully',
  'database.postgres.copyTableFail': 'Failed to copy table',
  'database.postgres.editTableTip':
    'Use DDL SQL statements to edit table structure',
  'database.postgres.ddlSqlPlaceholder': 'Enter DDL SQL statement',
  'database.postgres.ddlSqlRequired': 'Please enter DDL SQL statement',
  'database.postgres.fetchTableSchemaFail': 'Failed to fetch table schema',
  'database.postgres.editTableSuccess': 'Table updated successfully',
  'database.postgres.editTableFail': 'Failed to update table',
  // Table Structure
  'database.postgres.columnName': 'Column Name',
  'database.postgres.dataType': 'Data Type',
  'database.postgres.nullable': 'Nullable',
  'database.postgres.defaultValue': 'Default Value',
  'database.postgres.primaryKey': 'Primary Key',
  'database.postgres.maxLength': 'Max Length',
  // Table Data Management
  'database.postgres.selectField': 'Select Field',
  'database.postgres.operator': 'Operator',
  'database.postgres.inputValue': 'Value',
  'database.postgres.search': 'Search',
  'database.postgres.reset': 'Reset',
  'database.postgres.addRow': 'Add Row',
  'database.postgres.showFields': 'Show Fields',
  'database.postgres.deleteRowConfirm': 'Delete Row Confirm',
  'database.postgres.deleteRowConfirmContent':
    'Are you sure you want to delete this row?',
  'database.postgres.defaultValueTip': 'Default value: {value}',
  'database.postgres.operatorEqual': 'Equal',
  'database.postgres.operatorNotEqual': 'Not Equal',
  'database.postgres.operatorGreater': 'Greater Than',
  'database.postgres.operatorGreaterEqual': 'Greater Than or Equal',
  'database.postgres.operatorLess': 'Less Than',
  'database.postgres.operatorLessEqual': 'Less Than or Equal',
  'database.postgres.operatorLike': 'Contains',
  'database.postgres.operatorStarts': 'Starts With',
  'database.postgres.operatorEnds': 'Ends With',
  'database.postgres.operatorIsNull': 'Is Null',
  'database.postgres.operatorIsNotNull': 'Is Not Null',
  // SQL Execution
  'database.postgres.sqlPlaceholder': 'Enter SQL statement',
  'database.postgres.clearSQL': 'Clear',
  'database.postgres.executeSQL': 'Execute',
  'database.postgres.sqlEmptyState':
    'Enter a SQL statement above and click Execute',
  'database.postgres.sqlInputRequired': 'Please enter a SQL statement',
  'database.postgres.sqlExecuteSuccess':
    'Executed successfully, {rows} rows affected',
  'database.postgres.sqlExecuteFail': 'Execution failed: {error}',
  'database.postgres.sqlHistory': 'Execution History',
  'database.postgres.sqlHistoryEmpty': 'No execution history',
  'database.postgres.sqlHistoryClickToRestore': 'Click to restore to editor',
  'database.postgres.sqlHistoryFetchFail': 'Failed to fetch execution history',
  'database.postgres.sqlStatusSuccess': 'Success',
  'database.postgres.sqlStatusFailed': 'Failed',
  // Create Table Modal
  'database.postgres.createTableModal.title': 'Create Table',
  'database.postgres.createTableModal.ddlTip':
    'Use DDL SQL statements to create a table',
  'database.postgres.createTableModal.ddlPlaceholder':
    'CREATE TABLE my_table (\n  id SERIAL PRIMARY KEY,\n  name VARCHAR(255) NOT NULL\n);',
  'database.postgres.createTableModal.ddlRequired':
    'Please enter DDL SQL statement',
  'database.postgres.createTableModal.createSuccess':
    'Table created successfully',
  'database.postgres.createTableModal.createFail': 'Failed to create table',
  // usePostgres hook messages
  'database.postgres.addRowSuccess': 'Row added successfully!',
  'database.postgres.addRowFail': 'Failed to add row: {error}',
  'database.postgres.deleteRowSuccess': 'Row deleted successfully!',
  'database.postgres.deleteRowFail': 'Failed to delete row: {error}',
  'database.postgres.getTableColumnsFail':
    'Failed to get columns for table {table}: {error}',
  'database.postgres.getTableDataFail':
    'Failed to get data for table {table}: {error}',
  'database.postgres.executeSQLSuccess': 'SQL executed successfully!',
  'database.postgres.executeSQLFail': 'SQL execution failed: {error}',
  'database.postgres.addRowModal.title': 'Add Row',
  'database.postgres.fieldRequired': '{name} cannot be empty',
  // SQLite messages
  'database.sqlite.getTableListFailed': 'Failed to get table list',
  'database.sqlite.addTableSuccess': 'Table {name} added successfully',
  'database.sqlite.addTableFailed': 'Failed to add table {name}',
  'database.sqlite.deleteTableSuccess': 'Table {name} deleted successfully',
  'database.sqlite.deleteTableFailed': 'Failed to delete table {name}',
  'database.sqlite.getColumnsFailed':
    'Failed to get column info for table {name}',
  'database.sqlite.getDataFailed': 'Failed to get data for table {name}',
  'database.sqlite.addRowSuccess': 'Row added successfully',
  'database.sqlite.addRowFailed': 'Failed to add row',
  'database.sqlite.updateRowSuccess': 'Row updated successfully',
  'database.sqlite.updateRowFailed': 'Failed to update row',
  'database.sqlite.deleteRowSuccess': 'Row deleted successfully',
  'database.sqlite.deleteRowFailed': 'Failed to delete row',
  'database.sqlite.clearTableSuccess': 'Table {name} data cleared successfully',
  'database.sqlite.clearTableFailed': 'Failed to clear table {name} data',
  'database.sqlite.sqlExecuteSuccess': 'SQL executed successfully',
  'database.sqlite.sqlExecuteFailed': 'SQL execution failed: {error}',
  'database.sqlite.alterTableSuccess':
    'Table {name} structure modified successfully',
  'database.sqlite.alterTableFailed':
    'Failed to modify table {name} structure: {error}',
  'database.sqlite.modifyColumnNotSupported':
    'SQLite does not support direct column modification. Please use one of the following methods:\n1. Rebuild the table using SQL statements\n2. Use RENAME COLUMN to rename columns (SQLite 3.25.0+)\n3. Use DROP COLUMN + ADD COLUMN (SQLite 3.35.0+)',
  'database.sqlite.enterSqlStatement': 'Please enter SQL statement',
  'database.sqlite.executionFailed': 'Execution failed: {error}',
  'database.sqlite.columnNameRequired': 'Column name cannot be empty',
  'database.sqlite.columnNameDuplicate': 'Column name cannot be duplicated',
  'database.sqlite.renameColumnSuccess': 'Column renamed successfully',
  'database.sqlite.renameColumnFailed': 'Failed to rename column: {error}',
  'database.sqlite.createTable': 'Create Table',
  'database.sqlite.confirmDeleteTable':
    'Are you sure you want to delete this table?',
  'database.sqlite.tabStructure': 'Structure',
  'database.sqlite.tabContent': 'Content',
  'database.sqlite.tabQuery': 'Query',
  'database.sqlite.selectField': 'Select field',
  'database.sqlite.operator': 'Operator',
  'database.sqlite.inputValue': 'Enter value',
  'database.sqlite.query': 'Query',
  'database.sqlite.reset': 'Reset',
  'database.sqlite.addRow': 'Add Row',
  'database.sqlite.clear': 'Clear',
  'database.sqlite.showFields': 'Show Fields',
  'database.sqlite.selectFieldsToShow': 'Select fields to show',
  'database.sqlite.primaryKey': 'PK',
  'database.sqlite.fieldDefaultValue': 'Default value: {value}',
  'database.sqlite.confirmDeleteField':
    'Are you sure you want to delete this field?',
  'database.sqlite.clearTableData': 'Clear Table Data',
  'database.sqlite.confirmClearData': 'Confirm clear data?',
  'database.sqlite.clearDataWarning':
    'Data cannot be recovered after clearing, please proceed with caution.',
  'database.sqlite.opEquals': 'Equals',
  'database.sqlite.opNotEquals': 'Not Equals',
  'database.sqlite.opGreaterThan': 'Greater Than',
  'database.sqlite.opGreaterOrEqual': 'Greater or Equal',
  'database.sqlite.opLessThan': 'Less Than',
  'database.sqlite.opLessOrEqual': 'Less or Equal',
  'database.sqlite.opContains': 'Contains',
  'database.sqlite.opStartsWith': 'Starts With',
  'database.sqlite.opEndsWith': 'Ends With',
  'database.sqlite.opIsNull': 'Is Null',
  'database.sqlite.opIsNotNull': 'Is Not Null',
  'database.sqlite.addField': 'Add Field',
  'database.sqlite.fieldName': 'Field Name',
  'database.sqlite.enterFieldName': 'Please enter field name',
  'database.sqlite.enterNewColumnName': 'Please enter new column name',
  'database.sqlite.description': 'Description',
  'database.sqlite.enterFieldDescription': 'Please enter field description',
  'database.sqlite.dataType': 'Data Type',
  'database.sqlite.selectDataType': 'Please select data type',
  'database.sqlite.size': 'Size',
  'database.sqlite.defaultValue': 'Default Value',
  'database.sqlite.isRequired': 'Required',
  'database.sqlite.isUnique': 'Unique',
  'database.sqlite.autoIncrement': 'Auto Increment',
  'database.sqlite.isNotNull': 'Not Null',
  'database.sqlite.delete': 'Delete',
  'database.sqlite.builtInField': 'Built-in field',
  'database.sqlite.createTableTitle': 'Create Table',
  'database.sqlite.tableName': 'Table Name',
  'database.sqlite.enterTableName': 'Please enter table name',
  'database.sqlite.tableFields': 'Table Fields',
  'database.sqlite.pleaseAddFields': 'Please add fields',
  'database.sqlite.fieldNameRequired': 'Field name cannot be empty!',
  'database.sqlite.fieldNameDuplicate': 'Field name cannot be duplicated!',
  'database.sqlite.primaryKeyRequired': 'Please specify a primary key!',
  'database.sqlite.addFieldTitle': 'Add Field',
  'database.sqlite.enterDefaultValue': 'Enter default value (optional)',
  'database.sqlite.addRowTitle': 'Add Row',
  'database.sqlite.createdAt': 'Created At',
  'database.sqlite.enterSql': 'Enter SQL statement',
  'database.sqlite.execute': 'Execute',
  'database.sqlite.confirmDeleteColumn':
    'Are you sure you want to delete this column?',
  // Common
  'common.back': 'Back',
  'common.cancel': 'Cancel',
  'common.confirm': 'Confirm',
};
